import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/* Shared GET cache + in-flight dedupe. Several widgets mount at the same time on
   the Dashboard and all asked for /settings — one request now serves them all. */
const _cache = new Map();
export function cachedGet(path, ttl = 60000) {
  const hit = _cache.get(path);
  const now = Date.now();
  if (hit && now - hit.t < ttl) return hit.p;
  const p = api.get(path);
  _cache.set(path, { t: now, p });
  p.catch(() => _cache.delete(path));
  return p;
}
export function invalidateCache(path) {
  if (path) _cache.delete(path);
  else _cache.clear();
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
